import { AxiosResponse } from "axios"
// @ts-ignore
import api from "../libs/api"
import { EditProfileFormFields } from "../forms/EditProfile"

export async function editProfile(user: EditProfileFormFields): Promise<AxiosResponse<{token: string}>> {
  return api({method: 'patch', url: `/profile`, data: user})
}